import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";

import CGMExpiredStatusCard from "./CGMExpiredStatusCard";
import CGMStatusCardDefault from "./CGMStatusCardDefault";
import CGMDisconnectedCard from "./CGMDisconnectedCard";
import CGMBluetoothOffStatusCard from "./CGMBluetoothOffStatusCard";
import CGMErrorStatusCard from "./CGMErrorStatusCard";

import * as cgmActions from "src/redux/slices/cgmSlice";
import { CGM_DISPLAY_STATUS_CONFIG } from "src/constants/cgm";
import useCgmHook from "src/hooks/useCgm.hook";

const CGMStatusCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const { status, sensorInfo } = useCgmHook();
  const { latestReadings } = useAppSelector((state) => state.cgm);

  console.log("sensorInfo", sensorInfo);
  console.log("latestReadings", latestReadings);

  const cfg = CGM_DISPLAY_STATUS_CONFIG[status.code];

  useEffect(() => {
    dispatch(cgmActions.getCgmStatusRequest());
  }, [dispatch]);

  console.log("status", status);

  if (
    latestReadings.length > 0 &&
    latestReadings[0].errorCode &&
    latestReadings[0].errorCode !== "NONE"
  ) {
    return (
      <CGMErrorStatusCard
        color={CGM_DISPLAY_STATUS_CONFIG["ERROR"].color}
        bgColor={CGM_DISPLAY_STATUS_CONFIG["ERROR"].bgColor}
        label={status.label}
        errorId={latestReadings[0].errorCode.toString()}
      />
    );
  }

  if (status.code === "EXPIRED") {
    return (
      <CGMExpiredStatusCard
        color={cfg.color}
        bgColor={cfg.bgColor}
        label={status.label}
      />
    );
  }

  if (status.code === "TRANSMITTER_DISCONNECT") {
    return (
      <CGMDisconnectedCard
        color={cfg.color}
        bgColor={cfg.bgColor}
        label={status.label}
      />
    );
  }

  if (status.code === "DISCONNECTED") {
    return (
      <CGMStatusCardDefault
        color={cfg.color}
        bgColor={cfg.bgColor}
        label={status.label}
        displayStatus={status.code}
      />
    );
  }

  if (status.code === "BLUETOOTH_OFF") {
    return (
      <CGMBluetoothOffStatusCard
        color={cfg.color}
        bgColor={cfg.bgColor}
        label={status.label}
      />
    );
  }

  return (
    <CGMStatusCardDefault
      color={cfg.color}
      bgColor={cfg.bgColor}
      label={status.label}
      displayStatus={status.code}
    />
  );
};

export default CGMStatusCard;
